import React from 'react';
import { Input } from '@/components';
import { Controller, useFormContext } from 'react-hook-form';
import cx from 'clsx';
import styles from './index.module.scss';
import { ErrorMessage } from '@hookform/error-message';
import { urlRegex } from '../../utils';

export const VisitPage = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <>
      <div className={styles.formItem}>
        <div className={styles.labelContainer}>
          <div className={cx(styles.label, styles.isRequired)}>Page Name</div>
        </div>
        <Controller
          control={control}
          name="data.name"
          render={({ field, fieldState }) => {
            return (
              <Input
                className={styles.input}
                placeholder="Please input the website name"
                value={field?.value}
                onChange={field?.onChange}
                error={!!fieldState.error}
                maxLength={30}
                showLength
              />
            );
          }}
          rules={{
            required: true,
          }}
        />
      </div>
      <div className={styles.formItem}>
        <div className={styles.labelContainer}>
          <div className={cx(styles.label, styles.isRequired)}>Page Link</div>
        </div>
        <Controller
          control={control}
          name="data.action_url"
          render={({ field, fieldState }) => {
            return (
              <Input
                className={styles.input}
                placeholder="Please input the link the users need to visit"
                value={field?.value}
                onChange={field?.onChange}
                error={!!fieldState.error}
              />
            );
          }}
          rules={{
            required: true,
            pattern: {
              value: urlRegex,
              message: 'Please input a valid Link.',
            },
          }}
        />
        <ErrorMessage
          errors={errors}
          name={`data.action_url`}
          render={({ message }) => {
            return <div className={styles.errorMessage}>{message}</div>;
          }}
        />
      </div>
    </>
  );
};
